const clientPaths = require('./client-path.js')

// 注意事项：包名修改 src\config\secret-key.js里的包名也要修改
const apps = {
  default: {
    schema: 'imee://',
    clientPath: clientPaths.default,
  },
  echo: {
    schema: 'echo://',
    // 客户端路径
    clientPath: clientPaths.echo,
    // 测试 安卓 苹果
    packages: ['com.example.echo', 'com.chat.whisper', 'com.fh.whisper.chat'],
    // 测试 正式
    iosPackages: [],
    // 测试 正式
    androidPackages: ['com.example.echo', 'com.chat.whisper'],
    // 正式 正式接口 测试（测试页与 vava 共用）
    hosts: ['www.echoapp.chat', 'dewidfp7zx5np.cloudfront.net', 'app.test.camfan.chat'],
    // 分享域名
    shareHost: process.env.VUE_APP_IS_RELEASE == 1 ? 'www.echoapp.chat' : 'app.test.camfan.chat',
    // 接口地址
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'dewidfp7zx5np.cloudfront.net' : 'app.test.camfan.chat',
  },
  joychat: {
    schema: 'joychat://',
    // 客户端路径
    clientPath: clientPaths.joychat,
    // 测试 正式
    packages: ['com.owner.chat', 'com.chat.joychat'],
    // 测试 正式
    iosPackages: [],
    // 测试 正式
    androidPackages: ['com.owner.chat', 'com.chat.joychat'],
    // 正式 正式 测试（测试页与 vava 共用）
    hosts: ['www.joyme.chat', 'app.joyme.chat', 'app.test.camfan.chat'],
    // 分享域名
    shareHost: process.env.VUE_APP_IS_RELEASE == 1 ? 'app.joyme.chat' : 'app.test.camfan.chat',
    // 接口地址
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'api.joyme.chat' : 'app.test.camfan.chat',
  },
  joyu: {
    schema: 'joyu://',
    // 客户端路径
    clientPath: clientPaths.joyu,
    // 测试 正式
    packages: ['com.example.joyu', 'com.mind.joyu'],
    // 测试 正式
    iosPackages: [],
    // 测试 正式
    androidPackages: ['com.example.joyu', 'com.mind.joyu'],
    // 正式 测试（测试页与 vava 共用）
    hosts: ['www.mind-link.chat', 'app.test.camfan.chat'],
    // 分享域名
    shareHost: process.env.VUE_APP_IS_RELEASE == 1 ? 'www.mind-link.chat' : 'app.test.camfan.chat',
    // 接口地址
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'sev.mind-link.chat' : 'app.test.camfan.chat',
  },
  kiko: {
    schema: 'kiko://',
    // 客户端路径
    clientPath: clientPaths.kiko,
    // 安卓测试 安卓正式 苹果测试 苹果正式
    packages: ['com.example.kiko', 'com.live.kiko', 'com.test.moodlink', 'com.date.moodlink'],
    // 测试 正式
    iosPackages: ['com.test.moodlink', 'com.date.moodlink'],
    // 测试 正式
    androidPackages: ['com.example.kiko', 'com.live.kiko'],
    // 正式 正式 正式 测试（测试页与 vava 共用）
    hosts: ['www.kikoapp.chat', 'www.inpulse.fun', 'app.inpulse.fun', 'app.test.camfan.chat'],
    // 分享域名
    shareHost: process.env.VUE_APP_IS_RELEASE == 1 ? 'www.kikoapp.chat' : 'app.test.camfan.chat',
    // 接口地址
    apiBaseURL: {
      android: process.env.VUE_APP_IS_RELEASE == 1 ? 'api.inpulse.fun' : 'app.test.camfan.chat',
      ios: process.env.VUE_APP_IS_RELEASE == 1 ? 'api.inpulse.cc' : 'app.test.camfan.chat',
    },
  },
  vava: {
    schema: 'imee://',
    // 客户端路径
    clientPath: clientPaths.vava,
    // 安卓测试 安卓正式 苹果测试 苹果正式
    packages: ['com.example.gcc', 'com.client.goparty', 'com.test.coach', 'com.tools.coach'],
    // 测试 正式
    iosPackages: ['com.test.coach', 'com.tools.coach'],
    // 测试 正式
    androidPackages: ['com.example.gcc', 'com.client.goparty'],
    // 正式 正式 测试
    hosts: ['www.camfan.chat', 'app.camfan.chat', 'app.test.camfan.chat'],
    // 分享域名
    shareHost: process.env.VUE_APP_IS_RELEASE == 1 ? 'app.camfan.chat' : 'app.test.camfan.chat',
    // 接口地址
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'api.camfan.chat' : 'app.test.camfan.chat',
  },
  vibeo: {
    schema: 'vibeo://',
    // 客户端路径
    clientPath: clientPaths.vibeo,
    // 测试 正式
    packages: ['com.example.vibeo', 'com.live.vibeo'],
    // 测试 正式
    iosPackages: [],
    // 测试 正式
    androidPackages: ['com.example.vibeo', 'com.live.vibeo'],
    // 正式 测试（测试页与 vava 共用）
    hosts: ['web.vervachat.com', 'app.test.camfan.chat'],
    // 分享域名
    shareHost: process.env.VUE_APP_IS_RELEASE == 1 ? 'web.vervachat.com' : 'app.test.camfan.chat',
    // 接口地址
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'vbi.vervachat.com' : 'app.test.camfan.chat',
  },
  whonow: {
    schema: 'whonow://',
    // 客户端路径
    clientPath: clientPaths.whonow,
    // 测试 正式
    packages: ['com.example.whonow', 'com.linkup.chat.whonow'],
    // 测试 正式
    iosPackages: [],
    // 测试 正式
    androidPackages: ['com.example.whonow', 'com.linkup.chat.whonow'],
    // 正式 测试（测试页与 vava 共用）
    hosts: ['www.linkup.chat', 'app.test.camfan.chat'],
    // 分享域名
    shareHost: process.env.VUE_APP_IS_RELEASE == 1 ? 'www.linkup.chat' : 'app.test.camfan.chat',
    // 接口地址
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'dwogpybf1cxs0.cloudfront.net' : 'app.test.camfan.chat',
  },
  nivoa: {
    schema: 'nivoa://',
    // 客户端路径
    clientPath: clientPaths.nivoa,
    // 测试 正式
    packages: ['com.example.nivoa', 'com.fun.nivoa'],
    // 测试 正式
    iosPackages: [],
    // 测试 正式
    androidPackages: ['com.example.nivoa', 'com.fun.nivoa'],
    // 正式 测试（测试页与 vava 共用）
    hosts: ['www.nivoa.chat', 'app.test.camfan.chat'],
    // 分享域名
    shareHost: process.env.VUE_APP_IS_RELEASE == 1 ? 'www.nivoa.chat' : 'app.test.camfan.chat',
    // 接口地址
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'api.nivoa.chat' : 'app.test.camfan.chat',
  },
  // vava web版本-只为pay-third-back返回用
  viora: {
    schema: 'viora://',
    // 客户端路径
    clientPath: clientPaths.viora,
    // 测试 正式
    packages: ['com.example.viora', 'com.aura.viora'],
    // 正式 测试
    iosPackages: [],
    // 测试 正式
    androidPackages: ['com.example.viora', 'com.aura.viora'],
    // 正式 测试
    hosts: ['webh5.viora.video', 'app.test.camfan.chat'],
    // 分享域名
    shareHost: process.env.VUE_APP_IS_RELEASE == 1 ? 'webh5.viora.video' : 'app.test.camfan.chat',
    // 接口地址
    apiBaseURL: process.env.VUE_APP_IS_RELEASE == 1 ? 'query1.viora.video' : 'app.test.camfan.chat',
  },
  vavaWeb: {
    packages: ['com.vava.chat.web'],
    iosPackages: [],
    androidPackages: ['com.vava.chat.web'],
  },
}

const baseConfig = {
  apps,
  // app包名 [测试 安卓 苹果] 简写，由 apps.packages 自动生成
  packageNameMap: Object.entries(apps).reduce((map, [shortName, app]) => {
    ;(app.packages || []).forEach((pkg) => {
      map[pkg] = shortName
    })
    return map
  }, {}),
  // 环境类型
  isRelease: process.env.VUE_APP_IS_RELEASE == 1,
  // 图片地址
  imgHost: process.env.VUE_APP_IS_RELEASE == 1 ? 'https://source.camfan.chat/' : 'https://source.camfan.chat/',
  // 右向左语言列表
  rtlLangs: ['ar', 'fa', 'he'],
  // 现有web包
  validWebPackage: ['vavaWeb'],
  // 现有app包
  validAppPackage: ['echo', 'joychat', 'joyu', 'kiko', 'vava', 'vibeo', 'whonow', 'nivoa', 'viora'],
  /**
   * postcss-pxtorem.rootValue 与 src/assets/style/variable.js 中 px→rem 共用基准。
   * 约定：375 设计稿宽度下配合 flexible，`html` 字号为视口宽 / 10，此时 1rem ≈ 37.5px。
   */
  remRootValue: 37.5,
  // 各包应用商店下载链接
  downloadLinks: {
    echo: {
      android: 'https://play.google.com/store/apps/details?id=com.chat.whisper',
      ios: 'https://apps.apple.com/us/app/echo-secret-share-virtual-link/id6479391629',
    },
    beautycircle: {
      android: '',
      ios: 'https://itunes.apple.com/app/id6771731152',
    },
    joychat: {
      android: 'https://play.google.com/store/apps/details?id=com.chat.joychat',
      ios: '',
    },
    joyu: {
      android: 'https://play.google.com/store/apps/details?id=com.mind.joyu',
      ios: '',
    },
    kiko: {
      android: 'https://play.google.com/store/apps/details?id=com.live.kiko',
      ios: '',
    },
    vava: {
      android: 'https://play.google.com/store/apps/details?id=com.client.goparty',
      ios: '',
    },
    vibeo: {
      android: 'https://play.google.com/store/apps/details?id=com.live.vibeo',
      ios: '',
    },
    whonow: {
      android: 'https://play.google.com/store/apps/details?id=com.live.whonow',
      ios: '',
    },
    nivoa: {
      android: 'https://play.google.com/store/apps/details?id=com.fun.nivoa',
      ios: '',
    },
    viora: {
      android: 'https://play.google.com/store/apps/details?id=xxxx',
      ios: 'xxxx',
    },
  },
}

module.exports = baseConfig
